import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Tooltip } from "./Tooltip";
import { Box } from "../Styling";
export const TooltipOnHover = _ref => {
  let {
    children,
    contentContainerProps,
    ...tooltipProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    closeOnOutsideClick: false
  }, tooltipProps), _ref2 => {
    let {
      ref,
      open,
      close
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, _extends({
      onMouseEnter: open,
      onMouseLeave: close
    }, contentContainerProps, {
      ref: ref
    }), children);
  });
};
//# sourceMappingURL=TooltipOnHover.js.map